import React, { Component, Fragment } from "react";
import Button from "../../../components/atoms/Button";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import TextBox from "../../../components/atoms/TextBox";
import SelectFiles from "../../../components/atoms/SelectFiles";
import DatePicker from "../../../components/atoms/DatePicker";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";

export class DokumenPerusahaan extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      akta_badan_usaha: {
        id: "deed-of-establishment",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
      akta_perubahan: {
        id: "deed-of-change",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
      sk_pengesahan: {
        id: "decree-of-legalization",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
      sk_perubahan: {
        id: "decree-of-change",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
      TDP: {
        id: "tdp",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: { documentEndDate: "1970-01-01" } },
      },
      SIUP: {
        id: "siup",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
      NPWP: {
        id: "npwp",
        loading: false,
        file: { name: "", value: "", done: false, loading: false, url: "" },
        data: { name: "parameters", value: {} },
      },
    };
  }
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  componentDidMount = () => {
    this._isMounted = true;
    if (this._isMounted) {
      //console.log("masuk sini");

      this.setData();
    }
  };
  setData = () => {
    const { profileState, setStateCompanyDocs } = this.props;
    //console.log("Set Data Kepanggil");
    //console.log(profileState);
    let {
      akta_badan_usaha,
      akta_perubahan,
      sk_pengesahan,
      sk_perubahan,
      NPWP,
      TDP,
      SIUP,
    } = this.state;
    const { documents } = profileState.list.customerInfo.corporate;
    for (let i = 0; i < documents.length; i++) {
      setStateCompanyDocs(documents[i].documentType, true);
      if (documents[i].documentType === "AP0") {
        akta_badan_usaha.data.value = {
          documentNumber: documents[i].documentNumber,
        };
        akta_badan_usaha.file.url = documents[i].documentFileUrl;
        this.setState({ akta_badan_usaha });
      }
      if (documents[i].documentType === "AP1") {
        akta_perubahan.data.value = {
          documentNumber: documents[i].documentNumber,
        };
        akta_perubahan.file.url = documents[i].documentFileUrl;
        this.setState({ akta_perubahan });
      }
      if (documents[i].documentType === "MK0") {
        sk_pengesahan.data.value = {
          documentNumber: documents[i].documentNumber,
        };
        sk_pengesahan.file.url = documents[i].documentFileUrl;
        this.setState({ sk_pengesahan });
      }
      if (documents[i].documentType === "MK1") {
        sk_perubahan.data.value = {
          documentNumber: documents[i].documentNumber,
        };
        sk_perubahan.file.url = documents[i].documentFileUrl;
        this.setState({ sk_perubahan });
      }
      if (documents[i].documentType === "NPW") {
        NPWP.data.value = { documentNumber: documents[i].documentNumber };
        NPWP.file.url = documents[i].documentFileUrl;
        this.setState({ NPWP });
      }
      if (documents[i].documentType === "TDP") {
        TDP.data.value = {
          documentNumber: documents[i].documentNumber,
          documentEndDate: documents[i].documentEndDate,
          documentBeginDate: documents[i].documentBeginDate,
        };
        TDP.file.url = documents[i].documentFileUrl;
        this.setState({ TDP });
      }
      if (documents[i].documentType === "SIU") {
        SIUP.data.value = {
          documentNumber: documents[i].documentNumber,
          documentEndDate: documents[i].documentEndDate,
          documentBeginDate: documents[i].documentBeginDate,
        };
        SIUP.file.url = documents[i].documentFileUrl;
        this.setState({ SIUP });
      }
    }
    // console.log({akta_badan_usaha, akta_perubahan});

    // <p>{JSON.stringify(profileState.list.customerInfo.corporate.documents)}</p>
  };
  updateState = (name, value, id) => {
    let files = this.state[id];
    files.data.value[name] = value;
    if (files.file.url) {
      files.file.url = "";
    }
    if (this._isMounted) {
      this.setState({ [id]: files });
    }
  };
  uploadFile = (name, value, id) => {
    let files = this.state[id];
    //console.log({ name, value: value, id });
    files.file.name = "file";
    files.file.value = value;
    files.file.done = "1 File Selected";
    if (this._isMounted) {
      this.setState({ [id]: files });
    }
  };
  loadingDone = (id) => {
    let dataUpload = this.state[id];
    dataUpload.loading = false;
    dataUpload.file.done = false;
    if (this._isMounted) {
      this.setState({ [id]: dataUpload });
      this.setData();
    }
  };
  submit = async (id) => {
    //console.log("mau submit nih");

    let { UploadCompanyDocs, SetError } = this.props;
    let dataUpload = this.state[id];
    // console.log("apemih === ",dataUpload)

    if (!dataUpload.file.value) {
      SetError("Upload file terlebih dahulu");
    } else if (Object.keys(dataUpload.data.value).length === 0) {
      SetError("Upload isi field terlebih dahulu");
    } else if (
      id === "TDP" &&
      (!dataUpload.data.value.documentNumber ||
        !dataUpload.data.value.documentBeginDate)
    ) {
      SetError("Upload isi field terlebih dahulu");
    } else if (
      id === "SIUP" &&
      (!dataUpload.data.value.documentNumber ||
        !dataUpload.data.value.documentEndDate ||
        !dataUpload.data.value.documentBeginDate)
    ) {
      SetError("Upload isi field terlebih dahulu");
    } else {
      dataUpload.loading = true;
      this.setState({ [id]: dataUpload });
      let { file, data } = dataUpload;
      // console.log({file, data});
      let sendData = [];
      let formData = new FormData();
      formData.append(file.name, file.value);
      formData.append(data.name, JSON.stringify(data.value));
      // for (var value of formData.values()) {
      // console.log({value});
      //  }
      //console.log("disini juga mau bgt submit");

      UploadCompanyDocs(dataUpload.id, formData, id, this.loadingDone);
    }
  };
  render() {
    // const {col, changeStep} = this.props;
    const { col, parameters, profileState, submit } = this.props;
    const {
      akta_badan_usaha,
      akta_perubahan,
      sk_pengesahan,
      sk_perubahan,
      NPWP,
      TDP,
      SIUP,
    } = this.state;

    return (
      <Fragment>
        {/* <p>{JSON.stringify(profileState.list.customerInfo.corporate.documents)}</p> */}
        <div className="d-flex align-items-center justify-content-start mb-5">
          <i className="fas fa-exclamation-triangle text-danger"></i>
          <label className="ml-2 label-kc">
            Pastikan Anda mengisi semua kolom yang tersedia dan menekan tombol{" "}
            <b>Simpan</b> di setiap kolomnya untuk memastikan data Anda
            tersimpan dalam sistem kami.
          </label>
        </div>

        <LabelWithInput
          label="No. Akta Pendirian Badan Usaha"
          col={col}
          {...this.props}
          note={null}
        >
          <TextBox
            name="akta"
            value={akta_badan_usaha.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState(
                "documentNumber",
                e.target.value,
                "akta_badan_usaha"
              )
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="akta"
            files={akta_badan_usaha.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "akta_badan_usaha");
            }}
            loading={akta_badan_usaha.file.loading}
            done={akta_badan_usaha.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={akta_badan_usaha.loading}
            onClick={() => {
              this.submit("akta_badan_usaha");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        <LabelWithInput
          label="Akta Perubahan"
          col={col}
          {...this.props}
          note={null}
        >
          <TextBox
            name="akta_perubahan"
            value={akta_perubahan.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState(
                "documentNumber",
                e.target.value,
                "akta_perubahan"
              )
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="akta_perubahan"
            files={akta_perubahan.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "akta_perubahan");
            }}
            loading={akta_perubahan.file.loading}
            done={akta_perubahan.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={akta_perubahan.loading}
            onClick={() => {
              this.submit("akta_perubahan");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        <LabelWithInput
          label="SK Pengesahan"
          col={col}
          {...this.props}
          note={null}
        >
          <TextBox
            name="sk_pengesahan"
            value={sk_pengesahan.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState(
                "documentNumber",
                e.target.value,
                "sk_pengesahan"
              )
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="sk_pengesahan"
            files={sk_pengesahan.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "sk_pengesahan");
            }}
            loading={sk_pengesahan.file.loading}
            done={sk_pengesahan.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={sk_pengesahan.loading}
            onClick={() => {
              this.submit("sk_pengesahan");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        <LabelWithInput
          label="SK Perubahan"
          col={col}
          {...this.props}
          note={null}
        >
          <TextBox
            name="sk_perubahan"
            value={sk_perubahan.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState("documentNumber", e.target.value, "sk_perubahan")
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="sk_perubahan"
            files={sk_perubahan.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "sk_perubahan");
            }}
            loading={sk_perubahan.file.loading}
            done={sk_perubahan.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={sk_perubahan.loading}
            onClick={() => {
              this.submit("sk_perubahan");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        {/* Change TDP => NUP */}
        <LabelWithInput label="NIB" col={col} {...this.props} note={null}>
          <TextBox
            name="tdp"
            value={TDP.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState("documentNumber", e.target.value, "TDP")
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label="Tgl. Terdaftar NIB"
          col={col}
          {...this.props}
          note={null}
        >
          <DatePicker
            name="daftar_tdp"
            value={
              TDP.data.value.documentBeginDate
                ? new Date(TDP.data.value.documentBeginDate)
                : ""
            }
            onChange={(e) =>
              this.updateState(
                "documentBeginDate",
                dateFormatIndo(e.value, "db"),
                "TDP"
              )
            }
          />
        </LabelWithInput>

        {/* <LabelWithInput
          label="Tgl. Berakhir TDP/NIB"
          col={col}
          {...this.props}
          note={null}
        >
          <DatePicker
            name="akhir_tdp"
            value={
              TDP.data.value.documentEndDate
                ? new Date(TDP.data.value.documentEndDate)
                : ""
            }
            onChange={(e) =>
              this.updateState(
                "documentEndDate",
                dateFormatIndo(e.value, "db"),
                "TDP"
              )
            }
          />
        </LabelWithInput> */}

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="tdp"
            files={TDP.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "TDP");
            }}
            loading={TDP.file.loading}
            done={TDP.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={TDP.loading}
            onClick={() => {
              this.submit("TDP");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        <LabelWithInput label="SIUP" col={col} {...this.props} note={null}>
          <TextBox
            name="siup"
            value={SIUP.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState("documentNumber", e.target.value, "SIUP")
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label="Tgl. Pendaftaran SIUP"
          col={col}
          {...this.props}
          note={null}
        >
          <DatePicker
            name="daftar_siup"
            value={
              SIUP.data.value.documentBeginDate
                ? new Date(SIUP.data.value.documentBeginDate)
                : ""
            }
            onChange={(e) =>
              this.updateState(
                "documentBeginDate",
                dateFormatIndo(e.value, "db"),
                "SIUP"
              )
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label="Tgl. Berakhir SIUP"
          col={col}
          {...this.props}
          note={null}
        >
          <DatePicker
            name="akhir_siup"
            value={
              SIUP.data.value.documentEndDate
                ? new Date(SIUP.data.value.documentEndDate)
                : ""
            }
            onChange={(e) =>
              this.updateState(
                "documentEndDate",
                dateFormatIndo(e.value, "db"),
                "SIUP"
              )
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="siup"
            files={SIUP.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "SIUP");
            }}
            loading={SIUP.file.loading}
            done={SIUP.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={SIUP.loading}
            onClick={() => {
              this.submit("SIUP");
            }}
          />
        </LabelWithInput>

        <hr className="border-dashed add-margin" />

        <LabelWithInput label="No. NPWP" col={col} {...this.props} note={null}>
          <TextBox
            name="npwp"
            value={NPWP.data.value.documentNumber || ""}
            onChange={(e) =>
              this.updateState("documentNumber", e.target.value, "NPWP")
            }
          />
        </LabelWithInput>

        <LabelWithInput
          label=""
          col={col}
          {...this.props}
          info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB"
        >
          <SelectFiles
            name="npwp"
            files={NPWP.file.url}
            extention=".pdf,.png,.jpg,.jpeg"
            onChange={(name, value) => {
              this.uploadFile(name, value, "NPWP");
            }}
            loading={NPWP.file.loading}
            done={NPWP.file.done}
            error={null}
          />
        </LabelWithInput>

        <LabelWithInput label="" col={col} {...this.props}>
          <Button
            width="small"
            color="blue"
            title="Simpan"
            loading={NPWP.loading}
            onClick={() => {
              this.submit("NPWP");
            }}
          />
        </LabelWithInput>

        <div className="bg-button add-margin">
          <Button
            onClick={() => submit(1)}
            width="big"
            color="outline"
            title="Sebelumnya"
          />
          <Button
            onClick={() => submit(3)}
            width="big"
            color="blue"
            title="Selanjutnya"
          />
        </div>
      </Fragment>
    );
  }
}

export default DokumenPerusahaan;
